import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * #628 — `_index` 최상단 "시작하기" 진입 카드 (biz-specs/getting-started-guide.md §6.2).
 * 클릭 시 `/getting-started` 로 이동. 대시보드 첫 화면 상단에 배치해 온보딩 진입점을 부각.
 */
export function GettingStartedCard() {
  const { t } = useTranslation();

  return (
    <Link
      to="/getting-started"
      aria-label={`${t('_index.gettingStarted.cardTitle')} — ${t('_index.gettingStarted.cardDesc')}`}
      data-tour="getting-started-card"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'var(--spacing-4)',
        padding: 'var(--spacing-4) var(--spacing-6)',
        marginBottom: 'var(--spacing-4)',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--color-surface-border)',
        background: 'linear-gradient(135deg, var(--color-brand-primary), var(--color-brand-secondary))',
        color: 'var(--color-text-inverse)',
        textDecoration: 'none',
      }}
    >
      <div>
        <div style={{ fontSize: 'var(--font-size-lg)', fontWeight: 700 }}>
          {t('_index.gettingStarted.cardTitle')}
        </div>
        <div style={{ fontSize: 'var(--font-size-sm)', opacity: 0.9, marginTop: 'var(--spacing-1)' }}>
          {t('_index.gettingStarted.cardDesc')}
        </div>
      </div>
      <span aria-hidden="true" style={{ fontSize: 'var(--font-size-xl)', flexShrink: 0 }}>
        &#x2192;
      </span>
    </Link>
  );
}
